<span v-translate="getTranslateOptions"></span>